import { combineTokens } from '@utils/css';

const FADE_TRANSITION_DURATION_MS = 200;
const fadeTransitionCls = "_vcfwpkl3g";
const tokens = combineTokens("--audio", {
  backgroundColor: "rgba(0,0,0,0)"
});
const containerCls = "_vcc1efmbwr";
const playerCls = "_vcp1ubu1x5";
const skeleton__wrapperCls = "_vcs1r4k6te";
const skeleton__durationCls = "_vcs1oxlzlx";
const skeleton__volumeCls = "_vcs1gsn2mq";
const skeleton__titleCls = "_vcs1h3nh4x";

export { FADE_TRANSITION_DURATION_MS, containerCls, fadeTransitionCls, playerCls, skeleton__durationCls, skeleton__titleCls, skeleton__volumeCls, skeleton__wrapperCls, tokens };
import "./audio-component.content.style.linaria.module.css";
//# sourceMappingURL=audio-component.content.style.js.map
